var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { createAnimationStyles } from './createAnimationStyles';
var stateMap = {
    entering: function (_a) {
        var enterAnimation = _a.enterAnimation;
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), createAnimationStyles(enterAnimation));
    },
    exiting: function (_a) {
        var exitAnimation = _a.exitAnimation;
        return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), createAnimationStyles(exitAnimation));
    }
};
var PageTransitionWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  backface-visibility: hidden;\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  transform-style: preserve-3d;\n  transform: translate3d(0, 0, 0);\n  width: 100%;\n  will-change: transform;\n\n  ", ";\n"], ["\n  backface-visibility: hidden;\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  transform-style: preserve-3d;\n  transform: translate3d(0, 0, 0);\n  width: 100%;\n  will-change: transform;\n\n  ", ";\n"])), function (_a) {
    var state = _a.state;
    return stateMap[state];
});
export { PageTransitionWrapper };
var templateObject_1, templateObject_2, templateObject_3;
